module.exports = __webpack_public_path__ + "static/media/arrowDown.ef8bb61f.svg";